export const createWallActions = (set, get) => ({

  getActiveWall: () => {
    const { walls, activeWallId } = get();
    return walls[activeWallId];
  },

  getOccupiedCells: (wallId) => {
    const id = wallId || get().activeWallId;
    return get().walls[id]?.occupiedCells || new Set();
  },

  setActiveWall: (wallId) => {
    set({ activeWallId: wallId });
  },

  clearWall: (wallId) => {
    const id = wallId || get().activeWallId;

    set((state) => ({
      walls: {
        ...state.walls,
        [id]: {
          ...state.walls[id],
          placedProducts: [],
          occupiedCells: new Set(),
        },
      },
    }));
  },
});
